import { render, staticRenderFns } from "./ProblemTag.vue?vue&type=template&id=3feb761c&scoped=true&"
import script from "./ProblemTag.vue?vue&type=script&lang=js&"
export * from "./ProblemTag.vue?vue&type=script&lang=js&"
import style0 from "./ProblemTag.vue?vue&type=style&index=0&id=3feb761c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3feb761c",
  null
  
)

export default component.exports